/* Copyright 2016-2022
   Kabandy
   Author: Jonathan Boosten
 */

import { ITime, ITimeSerialized } from ".";

export module PostDataModel {
    export interface IPostAttachment {
        id: string;
        name: string;
        projectId: string;
        type: number;
    }

    export interface IGenericPost {
        id: string;
        projectId: string;
        userId: string;
        targetId: string;
        targetType: number;
        conversationId: string | null;
        systemGenerated?: boolean;
        attachments: IPostAttachment[];
        content?: any;
        time: ITime | ITimeSerialized;
    }

    export interface IPost extends IGenericPost {
        time: ITime;
    }

    export interface IPostSerialized extends IGenericPost {
        time: ITimeSerialized;
    }

    export enum ETargetType {
        Project = 0
    };

    export enum EAttachmentType {
        ModelGroup = 0,
        Board = 1,
        Document = 2
    };

    export enum EContentText {
        Creation = "created",
        Deletion = "deleted",
        Lock = "locked",
        Unlock = "unlocked",
        Update = "updated",
        Upload = "uploaded"
    }
}
